exports = module.exports = require("../../../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/*---------------------------------------------------------------------------------------------\r\n *  Copyright (c) Microsoft Corporation. All rights reserved.\r\n *  Licensed under the MIT License. See License.txt in the project root for license information.\r\n *--------------------------------------------------------------------------------------------*/\r\n\r\n@keyframes codicon-spin {\r\n\t100% {\r\n\t\ttransform:rotate(360deg);\r\n\t}\r\n}\r\n\r\n.codicon-animation-spin {\r\n\tanimation: codicon-spin 1.5s linear infinite;\r\n}\r\n", ""]);

// exports
